import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Lock, ShoppingCart, X } from 'lucide-react';

const CHECKOUT_URL = '/checkout';

export function TrialBanner({ className = '' }) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div
      data-testid="trial-banner"
      className={`bg-gradient-to-r from-[#0D1B2A] to-[#1F3A5F] text-white px-4 py-3 flex items-center justify-between gap-3 ${className}`}
    >
      <div className="flex items-center gap-2 min-w-0">
        <Lock className="h-4 w-4 text-amber-400 flex-shrink-0" />
        <span className="text-sm font-medium truncate">
          Versión de prueba — 1 descarga disponible
        </span>
      </div>
      <div className="flex items-center gap-2 flex-shrink-0">
        <a href={CHECKOUT_URL}>
          <Button
            size="sm"
            className="bg-[#5B9B2F] hover:bg-[#4a8126] text-white text-xs h-8 px-3"
            data-testid="trial-banner-buy-btn"
          >
            <ShoppingCart className="h-3 w-3 mr-1" />
            Desbloquear todo
          </Button>
        </a>
        <button
          onClick={() => setDismissed(true)}
          className="text-white/60 hover:text-white p-1"
          data-testid="trial-banner-dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}

export function DownloadBlockOverlay({ onClose }) {
  return (
    <div
      data-testid="download-block-overlay"
      className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4"
    >
      <div className="bg-white rounded-xl max-w-md w-full p-6 text-center shadow-2xl">
        <div className="mx-auto w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mb-4">
          <Lock className="h-7 w-7 text-amber-600" />
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">
          Descarga no disponible
        </h2>
        <p className="text-gray-600 text-sm mb-6">
          Ya usaste tu descarga gratuita. Adquirí la suscripción para descargar todos tus informes sin límite.
        </p>
        <a href={CHECKOUT_URL} className="block">
          <Button
            className="w-full bg-[#5B9B2F] hover:bg-[#4a8126] text-white h-12 text-base font-semibold mb-3"
            data-testid="download-block-buy-btn"
          >
            <ShoppingCart className="h-5 w-5 mr-2" />
            Desbloquear informes completos
          </Button>
        </a>
        <Button
          variant="ghost"
          onClick={onClose}
          className="text-gray-500 text-sm"
          data-testid="download-block-close"
        >
          Cerrar
        </Button>
      </div>
    </div>
  );
}
